"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6866],{

/***/ 46574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70518);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98216);
/* harmony import */ var _styles_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90948);
/* harmony import */ var _styles_useThemeProps__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71657);
/* eslint-disable material-ui/mui-name-matches-component-name */





const Container = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
  createStyledComponent: (0,_styles_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles) => {
      const {
        ownerState
      } = props;
      return [styles.root, styles[`maxWidth${(0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(String(ownerState.maxWidth))}`], ownerState.fixed && styles.fixed, ownerState.disableGutters && styles.disableGutters];
    }
  }),
  useThemeProps: inProps => (0,_styles_useThemeProps__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    props: inProps,
    name: 'MuiContainer'
  })
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Container);

/***/ }),

/***/ 98216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28320);

/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 29296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_debounce; }
});

;// CONCATENATED MODULE: ./node_modules/@mui/utils/esm/debounce.js
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func, wait = 166) {
  let timeout;
  function debounced(...args) {
    const later = () => {
      func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }
  debounced.clear = () => {
    clearTimeout(timeout);
  };
  return debounced;
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/debounce.js

/* harmony default export */ var utils_debounce = (debounce);

/***/ }),

/***/ 32045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _createContainer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70518);



/**
 *
 * Demos:
 *
 * - [Container (Material UI)](https://mui.com/material-ui/react-container/)
 * - [Container (MUI System)](https://mui.com/system/react-container/)
 *
 * API:
 *
 * - [Container API](https://mui.com/system/api/container/)
 */
const Container = (0,_createContainer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Container);

/***/ }),

/***/ 68493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_content_types_ForumPost_ForumPost__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11504);
/* harmony import */ var _constants_urls__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26854);
/* harmony import */ var _styles_global_styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38816);





const ForumPostWrapper = (param)=>{
    let { item , inMasonryGrid , isForAdults =false  } = param;
    var _item_categories, _item_tags, _item_comments, _item_categories1, _item_tags1, _item_comments1;
    var _item_likes_count;
    const [likesCount, setLikesCount] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((_item_likes_count = item.likes_count) !== null && _item_likes_count !== void 0 ? _item_likes_count : 0);
    var _item_categories_map, _item_tags_map, _item_title, _item_categories_map1, _item_tags_map1, _item_title1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles_global_styled__WEBPACK_IMPORTED_MODULE_4__/* .ForumFlipWrapper */ .Tw, {
        item: true,
        xs: 12,
        md: inMasonryGrid ? 12 : 4,
        className: "forum-card ".concat(inMasonryGrid ? "h-full" : "h-fit"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "forum-content ".concat(inMasonryGrid ? "auto-cols-fr" : ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "front",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_content_types_ForumPost_ForumPost__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        id: item.id,
                        truncateContent: true,
                        gender: item.user_gender,
                        age: item.user_age,
                        name: item.user_name,
                        postDate: new Date(item.date_created),
                        tags: (_item_categories_map = (_item_categories = item.categories) === null || _item_categories === void 0 ? void 0 : _item_categories.map((cat)=>cat.name)) !== null && _item_categories_map !== void 0 ? _item_categories_map : [],
                        tagsInverse: (_item_tags_map = (_item_tags = item.tags) === null || _item_tags === void 0 ? void 0 : _item_tags.map((tags)=>tags.name)) !== null && _item_tags_map !== void 0 ? _item_tags_map : [],
                        title: (_item_title = item.title) !== null && _item_title !== void 0 ? _item_title : "Titel moet in CMS worden ingevoerd",
                        comments: item.comments.length,
                        content: item.content,
                        className: "forum-post forum-list",
                        likesCount: likesCount,
                        commentsCount: (item === null || item === void 0 ? void 0 : (_item_comments = item.comments) === null || _item_comments === void 0 ? void 0 : _item_comments.length) || 0,
                        setLikesCount: setLikesCount
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "back z-10",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_content_types_ForumPost_ForumPost__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        id: item.id,
                        truncateContent: true,
                        gender: item.user_gender,
                        age: item.user_age,
                        name: item.user_name,
                        postDate: new Date(item.date_created),
                        button: true,
                        tagsBack: (_item_categories_map1 = (_item_categories1 = item.categories) === null || _item_categories1 === void 0 ? void 0 : _item_categories1.map((cat)=>cat.name)) !== null && _item_categories_map1 !== void 0 ? _item_categories_map1 : [],
                        tagsInverseBack: (_item_tags_map1 = (_item_tags1 = item.tags) === null || _item_tags1 === void 0 ? void 0 : _item_tags1.map((tags)=>tags.name)) !== null && _item_tags_map1 !== void 0 ? _item_tags_map1 : [],
                        title: (_item_title1 = item.title) !== null && _item_title1 !== void 0 ? _item_title1 : "Titel moet in CMS worden ingevoerd",
                        comments: item.comments.length,
                        content: item.content,
                        className: "forum-post forum-list",
                        buttonUrl: "".concat(isForAdults ? _constants_urls__WEBPACK_IMPORTED_MODULE_3__/* ["default"].PAGES.FORUM_PARENTS */ .Z.PAGES.FORUM_PARENTS : _constants_urls__WEBPACK_IMPORTED_MODULE_3__/* ["default"].PAGES.FORUM_CHILDREN */ .Z.PAGES.FORUM_CHILDREN, "/").concat(item === null || item === void 0 ? void 0 : item.slug),
                        likesCount: likesCount,
                        commentsCount: (item === null || item === void 0 ? void 0 : (_item_comments1 = item.comments) === null || _item_comments1 === void 0 ? void 0 : _item_comments1.length) || 0,
                        setLikesCount: setLikesCount,
                        isBackSide: true
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ForumPostWrapper);


/***/ }),

/***/ 89582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SortBar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/debounce.js + 1 modules
var debounce = __webpack_require__(29296);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 3 modules
var Grid = __webpack_require__(89162);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./components/form/Dropdown/Dropdown.tsx + 1 modules
var Dropdown = __webpack_require__(72552);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./components/icons/FilterIcon/FilterIcon.tsx


const FilterIcon = (param)=>{
    let { color ="black" , ...props } = param;
    const { colors  } = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: 19,
        height: 19,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M2.07414 2.42682L2.07411 2.42679C1.91773 2.27041 2.0292 2 2.25087 2H16.7492C16.9704 2 17.0828 2.26999 16.926 2.4268L16.926 2.42681L11.1464 8.20712L11 8.35357V8.56065V16.7494C11 16.9499 10.7723 17.0702 10.6066 16.9542L10.6066 16.9541L8.10667 15.2048C8.03979 15.158 8 15.0815 8 15V8.56065V8.35357L7.85358 8.20713L2.07414 2.42682Z",
            stroke: colors[color].normal,
            strokeWidth: 1.2
        })
    });
};
/* harmony default export */ var FilterIcon_FilterIcon = (FilterIcon);

;// CONCATENATED MODULE: ./components/icons/ListIcon/ListIcon.tsx



const ListIcon = (param)=>{
    let { color ="black" , ...props } = param;
    const { colors  } = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: 19,
        height: 19,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M6.333 4.75h10.292M6.333 9.5h10.292M6.333 14.25h10.292M2.375 4.75h.008M2.375 9.5h.008M2.375 14.25h.008",
            stroke: colors[color].normal,
            strokeWidth: 1.583,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var ListIcon_ListIcon = (ListIcon);

// EXTERNAL MODULE: ./styles/theme.ts
var theme = __webpack_require__(18102);
;// CONCATENATED MODULE: ./components/form/SortBar/SortBar.tsx








const defaultSortOptions = [
    {
        name: "Titel (a-z)",
        value: "title"
    },
    {
        name: "Titel (z-a)",
        value: "-title"
    },
    {
        name: "Auteur (a-z)",
        value: "author"
    },
    {
        name: "Auteur (z-a)",
        value: "-author"
    },
    {
        name: "Datum (oud-nieuw)",
        value: "date_created"
    },
    {
        name: "Datum (nieuw-oud)",
        value: "-date_created"
    }
];
const defaultContentOptions = [
    {
        name: "Alle activiteiten",
        value: ""
    },
    {
        name: "Luisteren",
        value: "audio",
        icon: "\uD83D\uDC42\uD83C\uDFFC"
    },
    {
        name: "Lezen",
        value: "tip",
        icon: "\uD83D\uDCD6"
    },
    {
        name: "Doen",
        value: "assignment",
        icon: "✍️"
    },
    {
        name: "Kijken",
        value: "vlog",
        icon: "\uD83D\uDC40"
    }
];
function SortBar(param) {
    let { sortOptions =defaultSortOptions , contentOptions =defaultContentOptions , onSort , onTypeContent , hasContentOptionsFilter , waitTime =300  } = param;
    const { register  } = (0,index_esm/* useForm */.cI)();
    const handleSort = (x)=>{
        if (onSort) return onSort(x);
    };
    const handleContentTypes = (x)=>{
        if (onTypeContent) return onTypeContent(x);
    };
    const debouncedSort = (0,debounce/* default */.Z)(handleSort, waitTime);
    const debouncedContentSort = (0,debounce/* default */.Z)(handleContentTypes, waitTime);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !hasContentOptionsFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                name: "sort",
                placeholder: "Sorteer op",
                register: register,
                onChange: debouncedSort,
                iconLeft: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListIcon_ListIcon, {}),
                options: sortOptions,
                chevronColor: theme/* COLORS.black.normal */.DM.black.normal,
                placeholderClass: "text-black"
            }),
            hasContentOptionsFilter && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                            name: "sort",
                            placeholder: "Sorteer op",
                            register: register,
                            onChange: debouncedSort,
                            iconLeft: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListIcon_ListIcon, {}),
                            options: sortOptions,
                            chevronColor: theme/* COLORS.black.normal */.DM.black.normal,
                            placeholderClass: "text-black"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                            name: "activiteit",
                            placeholder: "Soort activiteit",
                            register: register,
                            onChange: debouncedContentSort,
                            iconLeft: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterIcon_FilterIcon, {}),
                            options: contentOptions,
                            chevronColor: theme/* COLORS.black.normal */.DM.black.normal,
                            placeholderClass: "text-black"
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 82624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$_": function() { return /* reexport */ Footer["default"]; },
  "rj": function() { return /* reexport */ Grid/* default */.ZP; },
  "VM": function() { return /* reexport */ Hero; },
  "tl": function() { return /* reexport */ Pagination; }
});

// UNUSED EXPORTS: Box, Header

// EXTERNAL MODULE: ./components/layout/Footer/Footer.tsx
var Footer = __webpack_require__(40541);
// EXTERNAL MODULE: ./components/layout/Header/Header.tsx + 9 modules
var Header = __webpack_require__(10318);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./components/layout/Hero/Hero.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: flex;\n      align-items: center;\n    "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n            min-height: inherit !important;\n            height: 512px;\n          "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n            min-height: ",
        "px !important;\n          "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 29px 41px 40px 41px;\n  position: relative;\n\n  ",
        "\n  .inner {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  @media (max-width: 767px) {\n    ",
        ";\n    padding: 29px 10px 40px 10px;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}





const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-13e0b941-0"
})(_templateObject3(), (param)=>{
    let { center  } = param;
    return center && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
}, (param)=>{
    let { showTags , mobileImageHeight  } = param;
    return showTags ? (0,styled_components_browser_esm/* css */.iv)(_templateObject1()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), mobileImageHeight || 512);
});
function Hero(param) {
    let { children , center =false , imageUrl , style , showTags , mobileImageHeight , darkenImage , verticallyCenter  } = param;
    const imageClassName = "left-0 top-0 z-[-1] object-cover";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        center: center,
        style: style,
        showTags: showTags,
        mobileImageHeight: mobileImageHeight,
        children: [
            imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: imageUrl,
                alt: "",
                fill: true,
                className: "".concat(imageClassName, " ").concat(darkenImage ? "brightness-50" : ""),
                priority: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                style: {
                    height: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    className: verticallyCenter ? "flex justify-center" : "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "inner sm:mt-0",
                        children: children
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-spinners-kit/lib/index.js
var lib = __webpack_require__(79608);
;// CONCATENATED MODULE: ./components/layout/Pagination/Pagination.styled.ts

function Pagination_styled_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  margin-top: 20px;\n  button {\n    background-color: white;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n  }\n  > button {\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 160%;\n    color: var(--color-black);\n  }\n\n  nav {\n    padding-left: 4px;\n    padding-right: 4px;\n\n    ol {\n      padding: 0;\n      display: flex;\n      justify-content: space-between;\n      list-style: none;\n\n      li {\n        /* display: none; */\n        button {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          padding: 6px 11px 4px 11px;\n          gap: 6px;\n\n          margin: 0 4px;\n\n          height: 30px;\n          min-width: 30px;\n\n          border-radius: 8px;\n          background: white;\n          border: 1px solid var(--color-teal);\n          color: var(--color-black);\n\n          &.active {\n            color: white;\n            background: var(--color-teal);\n          }\n        }\n\n        &:first-child,\n        &.active,\n        &.active-sibling {\n        }\n      }\n    }\n  }\n"
    ]);
    Pagination_styled_templateObject = function() {
        return data;
    };
    return data;
}

const PaginationWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-40469f9f-0"
})(Pagination_styled_templateObject());

;// CONCATENATED MODULE: ./components/layout/Pagination/Pagination.tsx






const getRange = (start, end)=>{
    const length = end - start + 1;
    return Array.from({
        length
    }, (_, i)=>start + i);
};
const clamp = (number, lower, upper)=>{
    return Math.min(Math.max(number, lower), upper);
};
const pagination = function(currentPage, pageTotal, pagesToShow) {
    let MINIMUM_PAGE_SIZE = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 5;
    let delta;
    currentPage = clamp(currentPage, 1, pageTotal);
    pagesToShow = clamp(pagesToShow, MINIMUM_PAGE_SIZE, pageTotal);
    const centerPagesToShow = pagesToShow - 5;
    const boundaryPagesToShow = pagesToShow - 3;
    if (pageTotal <= pagesToShow) {
        delta = pagesToShow;
    } else {
        delta = currentPage < boundaryPagesToShow || currentPage > pageTotal - boundaryPagesToShow ? boundaryPagesToShow : centerPagesToShow;
    }
    const range = {
        start: Math.round(currentPage - delta / 2),
        end: Math.round(currentPage + delta / 2)
    };
    if (range.start - 1 === 1 || range.end + 1 === pageTotal) {
        range.start += 1;
        range.end += 1;
    }
    let pages = currentPage > delta ? getRange(Math.min(range.start, pageTotal - delta), Math.min(range.end, pageTotal)) : getRange(1, Math.min(pageTotal, delta + 1));
    if (currentPage > pageTotal - boundaryPagesToShow && pageTotal > pagesToShow) {
        pages = getRange(pageTotal - delta, pageTotal);
    }
    const withDots = (value, pair)=>pages.length + 1 !== pageTotal ? pair : [
            value
        ];
    const lastPage = pages[pages.length - 1];
    if (pages[0] !== 1) {
        pages = withDots(1, [
            1,
            "..."
        ]).concat(pages);
    }
    if (lastPage && Number(lastPage) < pageTotal) {
        pages = pages.concat(withDots(pageTotal, [
            "...",
            pageTotal
        ]));
    }
    return pages;
};
function Pagination(param) {
    let { truncated =false , total =1 , onChange , isFetching  } = param;
    const [currentPage, setCurrentPage] = (0,react.useState)(1);
    const theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    // On route change, reset to page 1
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        setCurrentPage(1);
    }, [
        router.query
    ]);
    let pages = Array.from({
        length: total
    }, (v, i)=>i).map((i)=>i + 1);
    if (truncated) {
        pages = globalThis.innerWidth < 768 ? pagination(currentPage, total, 3, 5) : pagination(currentPage, total, 5, 7);
    }
    const handleChangePage = (page)=>{
        if (typeof page === "number") {
            setCurrentPage(page);
            if (onChange) onChange(page);
        }
    };
    const handlePrev = ()=>{
        if (currentPage > 1) {
            const newPage = currentPage - 1;
            setCurrentPage(newPage);
            if (onChange) onChange(newPage);
        }
    };
    const handleNext = ()=>{
        if (currentPage < total) {
            const newPage = currentPage + 1;
            setCurrentPage(newPage);
            if (onChange) onChange(newPage);
        }
    };
    const generateClassName = (index)=>{
        let classes = "";
        if (currentPage === index) {
            classes = "".concat(classes, " active");
        }
        return classes;
    };
    // If total is 0, return null
    if (total === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaginationWrapper, {
        children: [
            isFetching && /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.CircleSpinner, {
                size: 10,
                color: theme.colors.primary.normal
            }),
            !isFetching && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: handlePrev,
                        className: "text-[16px] font-[300] md:text-[18px]",
                        hidden: currentPage === 1,
                        children: "Vorige"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                            children: pages.map((page, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: ()=>handleChangePage(page),
                                        className: generateClassName(page),
                                        children: page
                                    })
                                }, index))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: handleNext,
                        className: "text-[16px] font-[300] md:text-[18px]",
                        hidden: currentPage === total,
                        children: "Volgende"
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 3 modules
var Grid = __webpack_require__(89162);
;// CONCATENATED MODULE: ./components/layout/index.ts








/***/ }),

/***/ 81401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZX": function() { return /* binding */ FORUM_POST_PER_PAGE; },
/* harmony export */   "wx": function() { return /* binding */ POST_PER_PAGE; },
/* harmony export */   "wy": function() { return /* binding */ WORKSHOP_PER_PAGE; }
/* harmony export */ });
/* unused harmony exports IOS_APP_URL, ANDROID_APP_URL */
/* provided dependency */ var process = __webpack_require__(34155);
const IOS_APP_URL = process.env.NEXT_PUBLIC_IOS_APP_URL;
const ANDROID_APP_URL = process.env.NEXT_PUBLIC_ANDROID_APP_URL;
const POST_PER_PAGE = 9;
const FORUM_POST_PER_PAGE = 10;
const WORKSHOP_PER_PAGE = 7;


/***/ }),

/***/ 44833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ AudienceName; }
/* harmony export */ });
var AudienceName;
(function(AudienceName) {
    AudienceName["Children"] = "Children";
    AudienceName["Adults"] = "Adults";
})(AudienceName || (AudienceName = {}));


/***/ }),

/***/ 64291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Forum; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/debounce.js + 1 modules
var debounce = __webpack_require__(29296);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js
var Container = __webpack_require__(46574);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 3 modules
var Grid = __webpack_require__(89162);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js
var useQuery = __webpack_require__(78551);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-spinners-kit/lib/index.js
var lib = __webpack_require__(79608);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./api/config.ts
var config = __webpack_require__(53839);
;// CONCATENATED MODULE: ./api/services/audience-content-item.service.ts

const AudienceContentItemService = {
    getAudienceContentItems: async (params)=>{
        const response = await config/* client.get */.L.get("/audience-content-item/published-content-items", {
            paramsSerializer: (params)=>new URLSearchParams(params).toString(),
            params
        });
        return response.data.items;
    },
    getPagedPublishedContentItems: async (params, signal)=>{
        const response = await config/* client.get */.L.get("/audience-content-item/paginated-published-content-items", {
            paramsSerializer: (params)=>new URLSearchParams(params).toString(),
            params,
            signal
        });
        return response.data;
    }
};

// EXTERNAL MODULE: ./components/buttons/Button.tsx
var Button = __webpack_require__(19499);
// EXTERNAL MODULE: ./components/buttons/TagList/TagList.tsx + 1 modules
var TagList = __webpack_require__(26150);
// EXTERNAL MODULE: ./components/content-types/ForumPost/ForumPostWrapper.tsx
var ForumPostWrapper = __webpack_require__(68493);
// EXTERNAL MODULE: ./components/form/Input/Input.tsx + 2 modules
var Input = __webpack_require__(60921);
// EXTERNAL MODULE: ./components/form/SortBar/SortBar.tsx + 2 modules
var SortBar = __webpack_require__(89582);
// EXTERNAL MODULE: ./components/icons/ChevronRight/ChevronRight.tsx
var ChevronRight = __webpack_require__(33080);
// EXTERNAL MODULE: ./components/icons/SearchIcon/SearchIcon.tsx
var SearchIcon = __webpack_require__(91288);
// EXTERNAL MODULE: ./components/layout/index.ts + 3 modules
var layout = __webpack_require__(82624);
// EXTERNAL MODULE: ./components/layout/PageWrapper/PageWrapper.tsx
var PageWrapper = __webpack_require__(59509);
// EXTERNAL MODULE: ./components/typography/index.tsx + 7 modules
var typography = __webpack_require__(65906);
// EXTERNAL MODULE: ./constants/app-configs.ts
var app_configs = __webpack_require__(81401);
// EXTERNAL MODULE: ./enums/audienceName.ts
var enums_audienceName = __webpack_require__(44833);
;// CONCATENATED MODULE: ./enums/contentItemType.ts
var ContentItemType;
(function(ContentItemType) {
    ContentItemType[ContentItemType["OpenLetter"] = 1] = "OpenLetter";
    ContentItemType[ContentItemType["Forum"] = 2] = "Forum";
})(ContentItemType || (ContentItemType = {}));

// EXTERNAL MODULE: ./styles/kinderen/index.styles.ts
var index_styles = __webpack_require__(52360);
// EXTERNAL MODULE: ./styles/theme.ts
var styles_theme = __webpack_require__(18102);
// EXTERNAL MODULE: ./utils/MapTypes.ts
var MapTypes = __webpack_require__(32170);
// EXTERNAL MODULE: ./utils/parseImageURL2.ts
var parseImageURL2 = __webpack_require__(38775);
;// CONCATENATED MODULE: ./pages/forum/index.tsx


























const forumSortOptions = [
    {
        name: "Titel (a-z)",
        value: "Title"
    },
    {
        name: "Titel (z-a)",
        value: "Title desc"
    },
    {
        name: "Auteur (a-z)",
        value: "AuthorName"
    },
    {
        name: "Auteur (z-a)",
        value: "AuthorName desc"
    },
    {
        name: "Datum (oud-nieuw)",
        value: "CreationTime"
    },
    {
        name: "Datum (nieuw-oud)",
        value: "CreationTime desc"
    }
];
var __N_SSP = true;
function Forum(param) {
    let { pageData , audienceName =enums_audienceName/* AudienceName.Children */.C.Children  } = param;
    var _pageData_themes_find, _result_items;
    const theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    const [selectedTag, setSelectedTag] = (0,react.useState)("");
    const [currentPage, setCurrentPage] = (0,react.useState)(1);
    const [search, setSearch] = (0,react.useState)("");
    const [searchInputValue, setSearchInputValue] = (0,react.useState)("");
    const [sort, setSort] = (0,react.useState)("CreationTime desc");
    const router = (0,next_router.useRouter)();
    const { maxCommentCount  } = router.query;
    const { data: result , isFetching  } = (0,useQuery/* useQuery */.a)({
        queryKey: [
            "forum",
            currentPage,
            search,
            sort,
            selectedTag,
            maxCommentCount
        ],
        queryFn: async (param)=>{
            let { signal  } = param;
            const data = await AudienceContentItemService.getPagedPublishedContentItems({
                ContentTypes: [
                    ContentItemType.Forum
                ],
                AudienceName: audienceName,
                ThemeId: selectedTag,
                Sorting: sort,
                SkipCount: currentPage * app_configs/* FORUM_POST_PER_PAGE */.ZX - app_configs/* FORUM_POST_PER_PAGE */.ZX,
                Filter: search,
                MaxResultCount: app_configs/* FORUM_POST_PER_PAGE */.ZX
            }, signal);
            setCurrentPage(currentPage);
            return data;
        },
        initialData: {
            totalCount: 0,
            items: []
        }
    });
    const changePage = (index)=>{
        if (index <= 1) {
            setCurrentPage(1);
        } else {
            setCurrentPage(index);
        }
    };
    const handleSearch = (e)=>{
        setSearchInputValue(e.target.value);
        (0,debounce/* default */.Z)(()=>{
            setCurrentPage(1);
            setSearch(e.target.value);
        }, 300)();
    };
    const handleSort = (x)=>{
        setSort(x);
    };
    var _pageData_pageTitle, _pageData_themes, _pageData_themes_find_name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageWrapper/* default */.Z, {
        seo: {
            title: (pageData === null || pageData === void 0 ? void 0 : pageData.seoTitle) ? pageData === null || pageData === void 0 ? void 0 : pageData.seoTitle : pageData === null || pageData === void 0 ? void 0 : pageData.pageTitle,
            description: (pageData === null || pageData === void 0 ? void 0 : pageData.seoDescription) ? pageData === null || pageData === void 0 ? void 0 : pageData.seoDescription : pageData === null || pageData === void 0 ? void 0 : pageData.pageSubtitle,
            image: (pageData === null || pageData === void 0 ? void 0 : pageData.seoImageId) ? (0,parseImageURL2/* default */.Z)(pageData === null || pageData === void 0 ? void 0 : pageData.seoImageId) : ""
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* Hero */.VM, {
                center: true,
                imageUrl: (0,parseImageURL2/* default */.Z)(pageData === null || pageData === void 0 ? void 0 : pageData.headerImageId, 1400),
                style: {
                    minHeight: 649,
                    position: "relative"
                },
                darkenImage: pageData === null || pageData === void 0 ? void 0 : pageData.hasDarkOverlayHeaderImage,
                darkenImageMobile: pageData === null || pageData === void 0 ? void 0 : pageData.hasDarkOverlayHeaderImage,
                mobileImageHeight: 649,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    className: "mt-[40px] max-w-[1384px] md:mt-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        container: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 8,
                            className: "mx-auto w-[100%]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* TitleWithHighlights */.J, {
                                    text: (_pageData_pageTitle = pageData === null || pageData === void 0 ? void 0 : pageData.pageTitle) !== null && _pageData_pageTitle !== void 0 ? _pageData_pageTitle : "",
                                    color: "white",
                                    className: "mt-[-80px] text-[46px] font-[400] sm:text-[46px] md:mt-0 md:text-center md:text-[64px]"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.P, {
                                    color: "white",
                                    variant: "light",
                                    className: "text-subtitleHeaderMobileSize md:text-subtitleHeaderSize text-center leading-[160%] font-[300]",
                                    style: {
                                        margin: "0 auto"
                                    },
                                    children: pageData === null || pageData === void 0 ? void 0 : pageData.pageSubtitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_styles/* HeroButtonWrapper */.mM, {
                                    className: "mx-auto mt-[40px] w-fit gap-5 md:flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            href: pageData === null || pageData === void 0 ? void 0 : pageData.questionSubmitButtonLink,
                                            variant: "headerMain",
                                            className: "forum-act mb-[16px] w-[300px] px-[5px] text-[18px] font-[400] text-white",
                                            children: pageData === null || pageData === void 0 ? void 0 : pageData.questionSubmitButtonText
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "infoReversed",
                                            href: pageData === null || pageData === void 0 ? void 0 : pageData.questionOthersButtonLink,
                                            className: "forum-act hover:bg-teal w-[300px] border border-white bg-[transparent] px-[5px] text-[18px] font-[400] text-white hover:border-none",
                                            children: pageData === null || pageData === void 0 ? void 0 : pageData.questionOthersButtonText
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                style: {
                    marginBottom: "80px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginBottom: "20px",
                            transform: "translateY(-50%)"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            className: "max-w-[1384px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagList/* default */.Z, {
                                tags: (_pageData_themes = pageData === null || pageData === void 0 ? void 0 : pageData.themes) !== null && _pageData_themes !== void 0 ? _pageData_themes : [],
                                selected: selectedTag,
                                prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H4, {
                                    style: {
                                        whiteSpace: "nowrap",
                                        display: "flex",
                                        alignItems: "flex-start",
                                        gap: "5px"
                                    },
                                    className: "forum-tag",
                                    children: "Onderwerp \uD83D\uDC49"
                                }),
                                suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {}),
                                onSelect: (x)=>{
                                    setSelectedTag(x);
                                    setCurrentPage(1);
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        className: "mx-[auto] mt-[-90px] max-w-[1384px] px-[32px] md:mt-[0px] md:mb-[56px]",
                        id: "posts",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            container: true,
                            spacing: "34px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: 9,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography.P, {
                                            hidden: isFetching,
                                            className: "text-[24px]",
                                            children: [
                                                result === null || result === void 0 ? void 0 : result.totalCount,
                                                " ",
                                                (result === null || result === void 0 ? void 0 : result.totalCount) === 1 ? "vraag" : "vragen"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: 3,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SortBar/* default */.Z, {
                                            sortOptions: forumSortOptions,
                                            onSort: handleSort
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: 8,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex h-[100%] flex-col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "/forumbothead.png",
                                                    alt: "forum search",
                                                    fill: true,
                                                    className: "relative hidden max-h-[250px] w-[100%] rounded-t-[8px] object-cover md:block"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "bg-pink rounded-lg p-[24px] md:h-[290px] md:rounded-t-none md:p-[32px]",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                className: "mb-4 hyphens-auto text-white md:mb-8",
                                                                lang: "nl",
                                                                children: pageData === null || pageData === void 0 ? void 0 : pageData.searchBarQuote
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "md:flex md:items-center",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "mt-[20px] flex-1 md:mt-[0px]",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                                        iconLeft: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon/* default */.Z, {
                                                                            color: styles_theme/* COLORS.white.normal */.DM.white.normal
                                                                        }),
                                                                        value: searchInputValue,
                                                                        placeholder: "Zoek in het Forum...",
                                                                        onChange: handleSearch,
                                                                        borderColor: "white",
                                                                        className: "[&_.input-field]:bg-pink [&_input]:text-white [&_input]:placeholder:text-white [&_input]:placeholder:opacity-40"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    isFetching && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: 4,
                                        className: "flex items-center justify-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.CircleSpinner, {
                                            size: 75,
                                            color: theme.colors.primary.normal
                                        })
                                    }),
                                    !isFetching && result.items && result.items.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: 4,
                                        className: "flex flex-col items-center justify-center gap-5 text-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography.P, {
                                                children: [
                                                    "Er zijn helaas geen vragen gevonden",
                                                    selectedTag && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            " met het onderwerp ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "font-bold",
                                                                children: (_pageData_themes_find_name = (_pageData_themes_find = pageData === null || pageData === void 0 ? void 0 : pageData.themes.find((tag)=>tag.id === selectedTag)) === null || _pageData_themes_find === void 0 ? void 0 : _pageData_themes_find.name) !== null && _pageData_themes_find_name !== void 0 ? _pageData_themes_find_name : ""
                                                            })
                                                        ]
                                                    }),
                                                    selectedTag && search ? " en" : search ? " met" : "",
                                                    search && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            " de zoekterm ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "font-bold",
                                                                children: search
                                                            })
                                                        ]
                                                    }),
                                                    ". \uD83D\uDE22"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                variant: "headerMain",
                                                className: "forum-act mb-[16px] px-[5px] text-[18px] font-[400] text-white",
                                                onClick: ()=>{
                                                    setSelectedTag("");
                                                    handleSearch({
                                                        target: {
                                                            value: ""
                                                        }
                                                    });
                                                    setCurrentPage(1);
                                                },
                                                children: "Terug naar alle vragen"
                                            })
                                        ]
                                    }),
                                    !isFetching && result.items && result.items.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: result === null || result === void 0 ? void 0 : (_result_items = result.items) === null || _result_items === void 0 ? void 0 : _result_items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ForumPostWrapper/* default */.Z, {
                                                item: (0,MapTypes/* mapToForumPost */.w)(item),
                                                isForAdults: audienceName == enums_audienceName/* AudienceName.Adults */.C.Adults
                                            }, item.id))
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* Pagination */.tl, {
                        total: Math.ceil((result === null || result === void 0 ? void 0 : result.totalCount) / app_configs/* FORUM_POST_PER_PAGE */.ZX),
                        truncated: true,
                        onChange: changePage,
                        isFetching: isFetching
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 38816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tw": function() { return /* binding */ ForumFlipWrapper; },
/* harmony export */   "hb": function() { return /* binding */ HeroBannerWrapper; },
/* harmony export */   "jL": function() { return /* binding */ ContainerWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89162);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32045);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50066);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  .title-wrap {\n    text-align: center !important;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto !important;\n    width: 100%;\n  }\n\n  .subtitle {\n    font-size: 18px !important;\n    font-weight: 300 !important;\n    line-height: 160% !important;\n    font-family: "Avenir";\n    font-style: "normal";\n    color: var(--color-white) !important;\n  }\n\n  .title {\n    width: 100%;\n    font-size: 64px !important;\n    font-weight: 400 !important;\n    line-height: 140% !important;\n    font-family: "Fjalla One";\n    font-style: "normal";\n  }\n\n  &.zoeken-page {\n    .search {\n      font-size: 28px !important;\n      font-weight: 500 !important;\n\n      span {\n        font-size: 32px !important;\n        padding: 15px !important;\n        font-weight: 400 !important;\n      }\n    }\n\n    .title {\n      margin-bottom: 32px !important;\n      line-height: 118% !important;\n      font-size: 80px !important;\n    }\n  }\n\n  &.stel-een-vraag {\n    margin-top: -100px;\n  }\n\n  &.volunteer {\n    &.overview {\n      .overview-act {\n        border: 1px solid var(--color-white) !important;\n\n        &:hover {\n          border: none !important;\n        }\n      }\n\n      .title {\n        line-height: 140% !important;\n      }\n    }\n  }\n\n  @media (max-width: 767px) {\n    .title {\n      font-size: 46px !important;\n    }\n\n    .subtitle {\n      font-size: 16px !important;\n    }\n\n    &.stel-een-vraag {\n      margin-top: -50px;\n    }\n\n    &.training {\n      margin-top: 0px !important;\n    }\n\n    .volunteer.overvies {\n      .subtitle {\n        font-weight: 400 !important;\n      }\n    }\n\n    &.zoeken-page {\n      .search {\n        font-size: 20px !important;\n\n        span {\n          font-size: 18px !important;\n        }\n      }\n\n      .title {\n        margin-bottom: 32px !important;\n        line-height: 118% !important;\n        font-size: 46px !important;\n      }\n    }\n  }\n'
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .cardHeight {\n    max-height: ",
        ";\n    padding-top: 0;\n  }\n\n  &.lg-container {\n    max-width: 1384px !important;\n  }\n\n  &.sm-container {\n    max-width: 1118px;\n  }\n\n  @media (max-width: 767px) {\n    ul {\n      max-height: 400px;\n      height: 100%;\n    }\n\n    .cardHeight {\n      margin-top: 40px;\n    }\n\n    &.zoeken {\n      margin-top: -80px !important;\n\n      section > p {\n        font-size: 30px;\n      }\n\n      ul > li {\n        font-size: 16px;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &.form-card {\n    perspective: 4000px;\n    position: relative;\n    height: 600px;\n  }\n\n  .front .main-forum.forum-post {\n    background: var(--color-pink);\n    width: 100%;\n\n    .forum-tags span {\n      color: var(--color-pink);\n    }\n  }\n\n  .back .main-forum.forum-post {\n    background: var(--color-teal) !important;\n    width: 100%;\n  }\n\n  .forum-content {\n    display: grid;\n    place-items: center;\n    position: relative;\n    width: 100%;\n    height: 100%;\n    box-shadow: none;\n    text-align: left;\n\n    transition: transform 1s;\n    transform-style: preserve-3d;\n\n    .custom_forum_tags {\n      line-height: 1.5;\n    }\n  }\n\n  &.forum-card:hover .forum-content {\n    transform: rotateY(180deg);\n    transition: transform 0.5s;\n\n    .back .main-forum.forum-post.forum-list {\n      .forum-tags span {\n        background: var(--color-teal);\n        color: var(--color-white);\n      }\n\n      .back-act {\n        background: var(--color-teal) !important;\n        border: none !important;\n      }\n    }\n  }\n\n  .front,\n  .back {\n    grid-area: 1 / 1;\n    height: 100%;\n    width: 100%;\n    line-height: 300px;\n    font-size: 60px;\n    border-radius: 5px;\n    backface-visibility: hidden;\n  }\n\n  .back {\n    h4,\n    h3,\n    p,\n    div {\n      color: var(--color-white) !important;\n    }\n\n    transform: rotateY(180deg);\n  }\n\n  .back .main-forum.forum-post .forum-tags .forum-tag {\n    color: var(--color-white);\n    background: var(--color-pink);\n  }\n\n  .front .forum-tags span {\n    color: var(--color-pink);\n  }\n\n  .front .main-forum.forum-post.forum-list {\n    .forum-tags span {\n      color: var(--color-white);\n    }\n\n    .back-act {\n      background: var(--color-teal) !important;\n      border: none !important;\n    }\n  }\n\n  .back .main-forum.forum-post.forum-list {\n    .forum-tags span {\n      background: var(--color-white);\n      color: var(--color-teal);\n    }\n\n    .forum-link:hover {\n      button {\n        color: var(--color-white) !important;\n      }\n    }\n  }\n\n  .front .main-forum.forum-post.forum-list {\n    .forum-footer {\n      height: auto !important;\n    }\n  }\n\n  .back {\n    footer {\n      display: block;\n    }\n\n    .forum-secondary-button {\n      color: var(--color-white) !important;\n      margin-top: 10px;\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}



const HeroBannerWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d4a7782d-0"
})(_templateObject());
const ContainerWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d4a7782d-1"
})(_templateObject1(), (param)=>{
    let { cardHeight  } = param;
    return "".concat(cardHeight, "px");
});
const ForumFlipWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP).withConfig({
    componentId: "sc-d4a7782d-2"
})(_templateObject2());



/***/ }),

/***/ 52360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AS": function() { return /* binding */ ForumRulesWrapper; },
/* harmony export */   "cL": function() { return /* binding */ LetterFormWrapper; },
/* harmony export */   "mM": function() { return /* binding */ HeroButtonWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50066);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-image: url(",
        ");\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position-y: 266px;\n  padding-bottom: 130px;\n\n  @media (max-width: 767px) {\n    padding-bottom: 0px;\n  }\n\n  .comment-form-button {\n    color: var(--color-pink) !important;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  a {\n    border: 2px solid var(--color-white);\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  div,\n  p {\n    font-family: Avenir;\n    font-style: normal;\n    font-weight: 300;\n    font-size: 18px;\n    line-height: 160%;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}

const LetterFormWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-61179226-0"
})(_templateObject(), (props)=>props.bgImage);
const HeroButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-61179226-1"
})(_templateObject1());
const ForumRulesWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-61179226-2"
})(_templateObject2());



/***/ }),

/***/ 32170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ transformContentItemOpenLetterToLetter; },
/* harmony export */   "w": function() { return /* binding */ mapToForumPost; }
/* harmony export */ });
const transformContentItemOpenLetterToLetter = (openLetter)=>{
    var _openLetter_themes, _openLetter_tags;
    return {
        id: openLetter.id,
        date_created: openLetter.creationTime || "",
        date_updated: openLetter.lastModificationTime || "",
        sort: openLetter.sort || 0,
        slug: openLetter.slug,
        status: openLetter.status,
        title: openLetter.title,
        title_highlighted: openLetter.title,
        detail_title: openLetter.title || "",
        detail_title_highlighted: openLetter.title || "",
        description: openLetter.description || "",
        content: openLetter.content || "",
        categories: ((_openLetter_themes = openLetter.themes) === null || _openLetter_themes === void 0 ? void 0 : _openLetter_themes.map((theme)=>({
                name: theme.name
            }))) || [],
        downloadable_document: openLetter.downloadFileId,
        image: openLetter.imageId,
        requires_signup: openLetter.registrationRequired,
        bg_color: openLetter.backgroundColour || "",
        tags: ((_openLetter_tags = openLetter.tags) === null || _openLetter_tags === void 0 ? void 0 : _openLetter_tags.map((tag)=>({
                name: tag.name
            }))) || []
    };
};
const mapToForumPost = (source)=>{
    return {
        age_categories: [],
        likes: [],
        status: "published",
        user_gender: "",
        id: source.id,
        date_created: source.creationTime,
        date_updated: source.lastModificationTime,
        title: source.title,
        content: source.message,
        categories: source.themes,
        likes_count: source.likesCount,
        slug: source.slug,
        user_name: source.authorName,
        user_age: source.authorAge,
        user_updated: source.lastModificationTime,
        comments: source.comments || [],
        tags: source.tags
    };
};


/***/ }),

/***/ 98029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ useMutation; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/modern/mutation.js
var mutation = __webpack_require__(59289);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/modern/notifyManager.js
var notifyManager = __webpack_require__(27037);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/modern/subscribable.js
var subscribable = __webpack_require__(7506);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/modern/utils.js
var utils = __webpack_require__(24139);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/modern/mutationObserver.js
// src/mutationObserver.ts




var MutationObserver = class extends subscribable/* Subscribable */.l {
  #client;
  #currentResult = void 0;
  #currentMutation;
  #mutateOptions;
  constructor(client, options) {
    super();
    this.#client = client;
    this.setOptions(options);
    this.bindMethods();
    this.#updateResult();
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this);
    this.reset = this.reset.bind(this);
  }
  setOptions(options) {
    const prevOptions = this.options;
    this.options = this.#client.defaultMutationOptions(options);
    if (!(0,utils/* shallowEqualObjects */.VS)(this.options, prevOptions)) {
      this.#client.getMutationCache().notify({
        type: "observerOptionsUpdated",
        mutation: this.#currentMutation,
        observer: this
      });
    }
    if (prevOptions?.mutationKey && this.options.mutationKey && (0,utils/* hashKey */.Ym)(prevOptions.mutationKey) !== (0,utils/* hashKey */.Ym)(this.options.mutationKey)) {
      this.reset();
    } else if (this.#currentMutation?.state.status === "pending") {
      this.#currentMutation.setOptions(this.options);
    }
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      this.#currentMutation?.removeObserver(this);
    }
  }
  onMutationUpdate(action) {
    this.#updateResult();
    this.#notify(action);
  }
  getCurrentResult() {
    return this.#currentResult;
  }
  reset() {
    this.#currentMutation?.removeObserver(this);
    this.#currentMutation = void 0;
    this.#updateResult();
    this.#notify();
  }
  mutate(variables, options) {
    this.#mutateOptions = options;
    this.#currentMutation?.removeObserver(this);
    this.#currentMutation = this.#client.getMutationCache().build(this.#client, this.options);
    this.#currentMutation.addObserver(this);
    return this.#currentMutation.execute(variables);
  }
  #updateResult() {
    const state = this.#currentMutation?.state ?? (0,mutation/* getDefaultState */.R)();
    this.#currentResult = {
      ...state,
      isPending: state.status === "pending",
      isSuccess: state.status === "success",
      isError: state.status === "error",
      isIdle: state.status === "idle",
      mutate: this.mutate,
      reset: this.reset
    };
  }
  #notify(action) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      if (this.#mutateOptions && this.hasListeners()) {
        const variables = this.#currentResult.variables;
        const context = this.#currentResult.context;
        if (action?.type === "success") {
          this.#mutateOptions.onSuccess?.(action.data, variables, context);
          this.#mutateOptions.onSettled?.(action.data, null, variables, context);
        } else if (action?.type === "error") {
          this.#mutateOptions.onError?.(action.error, variables, context);
          this.#mutateOptions.onSettled?.(
            void 0,
            action.error,
            variables,
            context
          );
        }
      }
      this.listeners.forEach((listener) => {
        listener(this.#currentResult);
      });
    });
  }
};

//# sourceMappingURL=mutationObserver.js.map
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/utils.js
var modern_utils = __webpack_require__(86290);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/modern/useMutation.js
"use client";

// src/useMutation.ts




function useMutation(options, queryClient) {
  const client = (0,QueryClientProvider/* useQueryClient */.NL)(queryClient);
  const [observer] = react.useState(
    () => new MutationObserver(
      client,
      options
    )
  );
  react.useEffect(() => {
    observer.setOptions(options);
  }, [observer, options]);
  const result = react.useSyncExternalStore(
    react.useCallback(
      (onStoreChange) => observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(onStoreChange)),
      [observer]
    ),
    () => observer.getCurrentResult(),
    () => observer.getCurrentResult()
  );
  const mutate = react.useCallback(
    (variables, mutateOptions) => {
      observer.mutate(variables, mutateOptions).catch(modern_utils/* noop */.Z);
    },
    [observer]
  );
  if (result.error && (0,modern_utils/* shouldThrowError */.L)(observer.options.throwOnError, [result.error])) {
    throw result.error;
  }
  return { ...result, mutate, mutateAsync: result.mutate };
}

//# sourceMappingURL=useMutation.js.map

/***/ }),

/***/ 78551:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useQuery; }
/* harmony export */ });
/* harmony import */ var _tanstack_query_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72536);
/* harmony import */ var _useBaseQuery_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20364);
"use client";

// src/useQuery.ts


function useQuery(options, queryClient) {
  return (0,_useBaseQuery_js__WEBPACK_IMPORTED_MODULE_0__/* .useBaseQuery */ .r)(options, _tanstack_query_core__WEBPACK_IMPORTED_MODULE_1__/* .QueryObserver */ .z, queryClient);
}

//# sourceMappingURL=useQuery.js.map

/***/ })

}]);